import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { TranslateService } from '@ngx-translate/core';

import { LoginFacade, NotificationFacade } from '@ridango/components';
import { AuthParametersFacade } from '@ridango/components/lib/auth/+state/auth-parameters';
import { AuthService, ResetCompleteEvent, RIDANGO_PASSWORD_RECOVERY_STEPS } from '@ridango/core';

import { take } from 'rxjs/operators';

import { HelperService } from '../../shared/services/helper.service';
import Env from '@ridango/core/env';
import { OnboardingService } from '@ridango/core/lib/services';
import { OnboardingType } from '@ridango/widgets';
import { takeUntil } from 'rxjs/operators';
import { BaseComponent } from '@ridango/core';
@Component({
    templateUrl: './password-recover-verification-page.component.html',
    styleUrls: ['./password-recover-verification-page.component.scss']
})
export class PasswordRecoverVerificationPageComponent extends BaseComponent implements OnInit, OnDestroy {
    steps = RIDANGO_PASSWORD_RECOVERY_STEPS;
    step = 3;
    formerCustomerFirstVisit = false;
    callback: string;
    private onboardingType = OnboardingType;

    constructor(
        @Inject('ENV') public env: Env,
        @Inject(DOCUMENT) private document: Document,
        public ridangoAuth: AuthService,
        private router: Router,
        private route: ActivatedRoute,
        private translate: TranslateService,
        private notification: NotificationFacade,
        private authParams: AuthParametersFacade,
        private onboardingService: OnboardingService,
        private loginFacade: LoginFacade,
        private helper: HelperService
    ) {
        super();
    }

    ngOnInit() {
        if (this.ridangoAuth.getLoginStatus()) {
            this.loginFacade.logout(false);
            this.helper.cleanupAfterLogout();
        }
        this.formerCustomerFirstVisit = this.route.snapshot.data['formerCustomerFirstVisit'];
        if (this.env.SIGN_ON_PAGE) {
            this.handleCallbackURL();
        }
    }

    handleResetComplete(event: ResetCompleteEvent) {
        const loginWhenResetPassword = this.env.REGISTRATION?.LOGIN_WHEN_RESET_PASSWORD ?? true;

        if (event.loginSuccessful && loginWhenResetPassword) {
            if (event.authAccessToken) {
                const callback = this.callback;
                this.authParams.reset();
                this.document.location.href = `${callback}?accessToken=${event.authAccessToken}`;
            } else {
                this.notification.success(this.translate.instant('LOCAL_PASSWORD_RESET_AND_LOGIN_SUCCESS'), {
                    showAfterRouteChange: true
                });

                if (this.env.DEEP_LINKING) {
                    this.onboardingService.onboardingStatus = this.onboardingType.COMPLETED;
                }

                this.router.navigate([this.translate.currentLang, 'account']);
            }
        } else {
            if (event.loginSuccessful && !loginWhenResetPassword) {
                this.notification.success(this.translate.instant('LOCAL_PASSWORD_RESET_SUCCESS'), {
                    showAfterRouteChange: true
                });
            }

            this.router.navigate([this.translate.currentLang, 'login']);
        }
    }

    handleCallbackURL() {
        this.authParams.callback$.pipe(take(2)).subscribe((callback) => {
            if (callback) {
                this.callback = callback;
            }
        });
        this.route.queryParams.pipe(takeUntil(this.componentDestroyed$)).subscribe((params) => {
            if (params.callback) {
                this.authParams.setCallback(params.callback);
            }
        });
    }
}
